import { render, staticRenderFns } from "./Specie.vue?vue&type=template&id=a4d11ce4&"
import script from "./Specie.vue?vue&type=script&lang=js&"
export * from "./Specie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports